import { Pipe, PipeTransform } from '@angular/core';
import { AccountsConfig } from '../model/AccountsConfig';
import { Pos } from '../model/Pos';
import { Exchange, EXCHANGES } from '../model/constants';

@Pipe({
  name: 'positionFilter'
})
export class PositionFilterPipe implements PipeTransform {

  transform(items: Pos[], accountsConfig: AccountsConfig, selectedItems: any[], exchangeName: string): any[] {
    if (exchangeName === EXCHANGES.bitfinexSwap) {
      return items
        // @ts-ignore
        .filter(item => accountsConfig.bitfinexSwap.includes(item.account.bitfinexAccountId));
    }
    return items
      .filter(item => accountsConfig.bitfinex.includes(item.account.abosAccountId))
      .filter(item => item.exchange !== Exchange.BITFINEX_SWAP)
      .filter(item => selectedItems.find(s => s === item.account.abosAccountId));
  }
}
